import React from 'react';
import { Link } from 'react-router-dom';
import TOLogo from '../../../static/images/TO/toyota-logo.svg'
import { Row, Image, Button } from 'react-bootstrap';
import returnHeaders from './MiscHeaders';
import pushAnalytics from '../../../analytics/pushAnalytics';

const COMPONENT_TREE = [{ component_name: 'UnknownError', component_version: '1.0.0' }];

class UnknownErrorView extends React.Component {
    render() {
        return (
            <div className="justify-content-center line-box">
                <div role="banner">
                    <Row className="">
                        <Image className="corner-logo absolute" alt="Toyota" src={require("../../../static/images/Toyota-Logo.svg").default} />
                    </Row>
                </div>
                <div role="main">
                    <Row className="justify-content-center location">
                        <div>Sign In</div>
                    </Row>
                    <Row className="title__TO left">Something went Wrong</Row>
                    {returnHeaders("ERROR", sessionStorage.AP_STYLE)}
                    <div>
                        <Link to="/" onClick={() => {
                            pushAnalytics('aa-action', { button_action: 'retryLogin', ctaText: 'Try Again', initiator: 'user' }, COMPONENT_TREE);
                        }}><Button data-testid="TryAgainButton" bsPrefix="float-left button__TO" type="button" >Try Again</Button></Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default UnknownErrorView;